export const common = {
  next: "Next",
  previous: "Previous",
  page: "Page",
  cancel: "Cancel",
  save: "Save",
  scrollToBottom: "Scroll to bottom",
  footer: {
    copyright: "© {{year}} Araria by WeBizz. All rights reserved.",
    about:
      "Araria is a platform for AI-powered conversations and interactions. It allows users to chat with AI models, upload images, and use a variety of AI features. Araria is a Brazilian product developed by WeBizz.",
    menu: "Menu",
    home: "Home",
    blog: "Blog",
    pricing: "Pricing",
    featureRequest: "Feature Request",
    resources: "Resources",
    support: "Support",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    accountDeletion: "Account Deletion",
    contact: "Contact",
    documentation: "Documentation",
    api: "API",
    github: "GitHub",
  },
  notFound: {
    title: "404",
    heading: "Page Not Found",
    description: "The page you're looking for doesn't exist or has been moved.",
    button: "Return Home",
  },
  folders: {
    create: "Create",
    new: "New Folder",
    namePlaceholder: "Enter folder name...",
    rename: "Rename folder",
    delete: "Delete folder",
    moveTo: "Move to {{name}}",
    removeFromFolder: "Remove from folder",
  },
  contact: {
    title: "Contact",
    subtitle: "Contact us",
    form: {
      name: "Name",
      email: "Email",
      company: "Company",
      message: "Message",
      submit: "Submit",
      success: "Message sent successfully",
      error: "Error sending message",
    },
  },
  user: {
    menu: {
      title: "User Menu",
      profile: "Profile",
      payments: "Payments",
      usage: "Usage",
      affiliate: "Affiliate Program",
      logout: "Logout",
      settings: "Settings",
      support: "Support",
      features: "Feature Request",
    },
  },
  soon: {
    title: "Coming Soon",
    heading: "Our team is working here!",
    description: "Follow our news in our blog and social media.",
    button: "Return Home",
    blog: "Blog",
  },
};
